/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable react/no-string-refs */
/* eslint-disable react/no-array-index-key */


import React, { Component } from 'react';
import { Card, CardDeck, CardBody, Col, Button, ButtonToolbar, ButtonGroup, ListGroup, ListGroupItem, Table, Input } from 'reactstrap';
import 'react-table/react-table.css';
import axios from 'axios';
import { connect } from 'react-redux';
import ActionButton from './ActionButton';


const currencyFormat = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
const URL = 'https://marketplace-api.musicmarquee.co.uk';
const SELLER_BACKEND_URL = 'https://api.musicmarquee.co.uk';


class ToolsUpdateOrders extends Component {
  constructor() {
    super();
    this.state = {
      updateOrdersStartDate: '',
      updateOrdersEndDate: '',
      updateOrdersClientId: '',
      updateOrdersClientMode: 'include',
      getNewOrdersStartDate: '',
      getNewOrdersEndDate: '',
      getNewOrdersClientId: '',
      getNewOrdersClientMode: 'include',
      clients: [],
      updateOrdersResponse: { complete: false, response: undefined },
      newOrderResponse: { complete: false, response: undefined },
      shippedResponse: { complete: false, response: undefined },
      updateBandsResponse: { complete: false, response: undefined },
      updateMerchResponse: { complete: false, response: undefined },
    };
  }

  componentDidMount() {
    this.getClients();
  }

  async getClients() {
    try {
      const response = await axios.post(
        `${SELLER_BACKEND_URL}/admin/bandcamp/filter-clients`,
        {},
        {
          headers: {
            Authorization: localStorage.getItem('mm_admin'),
          },
        },
      );

      this.setState({
        clients: response.data.clients || [],
      });
    } catch (error) {
      this.setState({
        updateOrdersResponse: {
          complete: false,
          response: 'Unable to load Bandcamp clients.',
        },
      });
    }
  }

  async getNewBandcampOrders() {
    try {
      const response = await axios.post(`${URL}/admin/bandcamp`, {
        startDate: this.state.getNewOrdersStartDate,
        endDate: this.state.getNewOrdersEndDate,
        clientId: this.state.getNewOrdersClientId,
        clientMode: this.state.getNewOrdersClientMode,
      }, { headers: { Authorization: localStorage.getItem('mm_admin') } });

      this.setState({
        newOrderResponse: { complete: true, response: this.formatGetNewOrdersResponse(response) },
      });
    } catch (error) {
      const responseMessage = error.response && error.response.data
        ? error.response.data
        : error.message;

      this.setState({
        newOrderResponse: { complete: false, response: `Unable to get new Bandcamp orders: ${responseMessage}` },
      });
    }

    return true;
  }

  formatGetNewOrdersResponse(response) {
    if (Array.isArray(response.data)) {
      if (response.data.length === 0) {
        return 'No new Bandcamp orders found.';
      }

      return response.data.map((message, index) => (
        <div key={index}>{message}</div>
      ));
    }

    if (response.data && typeof response.data === 'object') {
      if (Number.isInteger(response.data.ordersFetched)) {
        const orderLabel = response.data.ordersFetched === 1 ? 'order' : 'orders';
        return `${response.data.ordersFetched} new Bandcamp ${orderLabel} fetched.`;
      }

      return (
        <pre style={{ marginBottom: 0, whiteSpace: 'pre-wrap' }}>
          {JSON.stringify(response.data, null, 2)}
        </pre>
      );
    }

    if (response.status >= 200 && response.status < 300) {
      return 'New Bandcamp orders fetched.';
    }

    return response.data || `Request finished with status ${response.status}.`;
  }

  async updateBandcampOrders() {
    const response = await axios.post(`${URL}/admin/bandcamp/update`, {
      store: 'all',
      startDate: this.state.updateOrdersStartDate,
      endDate: this.state.updateOrdersEndDate,
      clientId: this.state.updateOrdersClientId,
      clientMode: this.state.updateOrdersClientMode,
    }, { headers: { Authorization: localStorage.getItem('mm_admin') } });
    this.setState({
      updateOrdersResponse: { complete: true, response: 'Orders Updated' },
    });
    return true;
  }

  async shipBandcampOrders() {
    const response = await axios.post(`${URL}/admin/bandcamp/ship`, {}, { headers: { Authorization: localStorage.getItem('mm_admin') } });
    this.setState({
      shippedResponse: { complete: true, response: `Shipped ${response.data.length} Orders.` },
    });
    return true;
  }

  formatErrorMessage(error) {
    if (error.response && error.response.data) {
      if (typeof error.response.data === 'object') {
        return JSON.stringify(error.response.data, null, 2);
      }

      return error.response.data;
    }

    return error.message;
  }

  formatActionResponse(response, fallbackMessage, actionLabel) {
    const finishedAt = new Date().toLocaleTimeString();

    if (response.data && Array.isArray(response.data.bands)) {
      const bandLabel = response.data.bands.length === 1 ? 'band' : 'bands';

      return (
        <div>
          <div>{`${actionLabel} completed at ${finishedAt}.`}</div>
          <div>{`${response.data.bands.length} ${bandLabel} fetched and sent to the database.`}</div>
        </div>
      );
    }

    if (response.data && Array.isArray(response.data.items)) {
      const itemLabel = response.data.items.length === 1 ? 'item' : 'items';

      return (
        <div>
          <div>{`${actionLabel} completed at ${finishedAt}.`}</div>
          <div>{`${response.data.items.length} ${itemLabel} returned by the backend.`}</div>
        </div>
      );
    }

    if (Array.isArray(response.data)) {
      const itemLabel = response.data.length === 1 ? 'item' : 'items';

      return `${actionLabel} completed at ${finishedAt}. ${response.data.length} ${itemLabel} returned.`;
    }

    if (response.data && typeof response.data === 'object') {
      return (
        <div>
          <div>{`${actionLabel} completed at ${finishedAt}.`}</div>
          <pre style={{ marginBottom: 0, whiteSpace: 'pre-wrap' }}>
            {JSON.stringify(response.data, null, 2)}
          </pre>
        </div>
      );
    }

    if (response.status >= 200 && response.status < 300) {
      return `${actionLabel} completed at ${finishedAt}. ${fallbackMessage}`;
    }

    return response.data || `${actionLabel} finished with status ${response.status}.`;
  }

  async updateBandcampBands() {
    try {
      this.setState({
        updateBandsResponse: {
          complete: false,
          response: `Updating bands... Started at ${new Date().toLocaleTimeString()}.`,
        },
      });

      const response = await axios.post(
        `${URL}/admin/bandcamp/bands`,
        {},
        { headers: { Authorization: localStorage.getItem('mm_admin') } },
      );

      this.setState({
        updateBandsResponse: {
          complete: true,
          response: this.formatActionResponse(response, 'Bands updated.', 'Update Bands'),
        },
      });
    } catch (error) {
      this.setState({
        updateBandsResponse: {
          complete: false,
          response: `Unable to update bands: ${this.formatErrorMessage(error)}`,
        },
      });
    }

    return true;
  }

  async updateBandcampMerch() {
    try {
      this.setState({
        updateMerchResponse: {
          complete: false,
          response: `Updating merch... Started at ${new Date().toLocaleTimeString()}.`,
        },
      });

      const response = await axios.post(
        `${URL}/admin/bandcamp/merch/update`,
        {},
        { headers: { Authorization: localStorage.getItem('mm_admin') } },
      );

      this.setState({
        updateMerchResponse: {
          complete: true,
          response: this.formatActionResponse(
            response,
            'Merch update completed. The backend did not return an item count.',
            'Update Merch',
          ),
        },
      });
    } catch (error) {
      this.setState({
        updateMerchResponse: {
          complete: false,
          response: `Unable to update merch: ${this.formatErrorMessage(error)}`,
        },
      });
    }

    return true;
  }

  render() {
    return (
      <Col style={{ height: '100%' }}>
        <Card style={{ width: '100%' }}>
          <CardBody>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Complete</th>
                  <th>Result</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: '20%' }}>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Bandcamp Orders"
                      task={() => this.updateBandcampOrders()}
                    />

                    <div style={{ marginTop: 10 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        Start Date
                      </label>
                      <Input
                        type="datetime-local"
                        bsSize="sm"
                        value={this.state.updateOrdersStartDate}
                        onChange={e => this.setState({ updateOrdersStartDate: e.target.value })}
                      />
                    </div>

                    <div style={{ marginTop: 8 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        End Date
                      </label>
                      <Input
                        type="datetime-local"
                        bsSize="sm"
                        value={this.state.updateOrdersEndDate}
                        onChange={e => this.setState({ updateOrdersEndDate: e.target.value })}
                      />
                    </div>

                    <div style={{ marginTop: 8 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        Client Mode
                      </label>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={this.state.updateOrdersClientMode}
                        onChange={e => this.setState({ updateOrdersClientMode: e.target.value })}
                      >
                        <option value="include">Include client</option>
                        <option value="exclude">Exclude client</option>
                      </Input>
                    </div>

                    <div style={{ marginTop: 8 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        Client
                      </label>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={this.state.updateOrdersClientId}
                        onChange={e => this.setState({ updateOrdersClientId: e.target.value })}
                      >
                        <option value="">All Clients</option>
                        {this.state.clients.map(client => (
                          <option key={client.id} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                  </td>
                  <td style={{ width: '10%' }}>{this.state.updateOrdersResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td style={{ width: '70%' }}>{this.state.updateOrdersResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Get New Bandcamp Orders"
                      task={() => this.getNewBandcampOrders()}
                    />
                    <div style={{ marginTop: 10 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        Start Date
                      </label>
                      <Input
                        type="datetime-local"
                        bsSize="sm"
                        placeholder="Select Date...."
                        value={this.state.getNewOrdersStartDate}
                        onChange={e => this.setState({ getNewOrdersStartDate: e.target.value })}
                      />
                    </div>

                    <div style={{ marginTop: 8 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        End Date
                      </label>
                      <Input
                        type="datetime-local"
                        bsSize="sm"
                        value={this.state.getNewOrdersEndDate}
                        onChange={e => this.setState({ getNewOrdersEndDate: e.target.value })}
                      />
                    </div>

                    <div style={{ marginTop: 8 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        Client Mode
                      </label>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={this.state.getNewOrdersClientMode}
                        onChange={e => this.setState({ getNewOrdersClientMode: e.target.value })}
                      >
                        <option value="include">Include client</option>
                        <option value="exclude">Exclude client</option>
                      </Input>
                    </div>

                    <div style={{ marginTop: 8 }}>
                      <label style={{ fontSize: 12, marginBottom: 4 }}>
                        Client
                      </label>
                      <Input
                        type="select"
                        bsSize="sm"
                        value={this.state.getNewOrdersClientId}
                        onChange={e => this.setState({ getNewOrdersClientId: e.target.value })}
                      >
                        <option value="">All Clients</option>
                        {this.state.clients.map(client => (
                          <option key={client.id} value={client.id}>
                            {client.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                  </td>
                  <td>{this.state.newOrderResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.newOrderResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Mark as shipped"
                      task={() => this.shipBandcampOrders()}
                    />
                  </td>
                  <td>{this.state.shippedResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.shippedResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Bands"
                      task={() => this.updateBandcampBands()}
                    />
                  </td>
                  <td>{this.state.updateBandsResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.updateBandsResponse.response || ''}</td>
                </tr>
                <tr>
                  <td>
                    <ActionButton
                      color="primary"
                      size="sm"
                      title="Update Merch"
                      task={() => this.updateBandcampMerch()}
                    />
                  </td>
                  <td>{this.state.updateMerchResponse.complete ? 'Complete' : 'Not Complete'}</td>
                  <td>{this.state.updateMerchResponse.response || ''}</td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

// export default connect()(SidebarContent);
export default connect(mapStateToProps)(ToolsUpdateOrders);
